import React from "react"
import { browserHistory } from "react-router"
import TextField from "material-ui/TextField"
import RaisedButton from "material-ui/RaisedButton"
import RefreshIndicator from "material-ui/RefreshIndicator"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AccountStore from "../../stores/AccountStore"
import dispatcher from "../../dispatcher"
import strings from "../../localization/strings"
import { amber600 } from "material-ui/styles/colors"
import * as utils from "../../helpers/utils"
import * as loginActions from "../../actions/LoginActions"
import * as permissionHelper from "../../helpers/permissionHelper"
import autobind from "class-autobind"
import { ELoggedInUserType } from "../../models"
import { enableIntercom } from "../../../intercom"
import RegistrationLayout from "../../components/registration/RegistrationLayout"
import HtmlLoader from "../../components/layout/HtmlLoader"
import { IAccountManagerFESettings } from "../../models/data/account_manager/AccountManagerFESettings"
import AppStateStore from "../../stores/AppStateStore"
import * as  appStateActions from "../../actions/AppStateActions"
import { isMobile } from "react-device-detect"

interface IState {
	email: string
	password: string
	emailErrorText: string
	passwordErrorText: string
	loginAttempted: boolean
	loadingStatus: string
	loadingLeft: number
	loadingTop: number
	sentRequestResetPassword: boolean
	passwordUpdated: boolean
	recaptchaResponse: string
	recaptchaErrorText: string,
	allValid: boolean,
	frontEndSettings: IAccountManagerFESettings,
}

export default class Login extends React.Component<null, IState> {
	constructor(props) {
		super(props)
		this.state = {
			email: "",
			password: "",
			emailErrorText: "",
			passwordErrorText: "",
			loginAttempted: false,
			loadingStatus: "hide",
			loadingLeft: window.innerWidth / 2 - 20,
			loadingTop: window.innerHeight / 2 - 20,
			sentRequestResetPassword: AuthenticationStore.getSentRequestResetPassword(),
			passwordUpdated: AuthenticationStore.getPasswordUpdated(),
			recaptchaResponse: null,
			recaptchaErrorText: null,
			allValid: false,
			frontEndSettings: AppStateStore.getFrontEndSettings(),
		}
		autobind(this)
	}

	frontEndSettingsChange() {
		this.setState({ frontEndSettings: AppStateStore.getFrontEndSettings() })
	}

	handleResize() {
		this.setState({
			loadingLeft: window.innerWidth / 2 - 20,
			loadingTop: window.innerHeight / 2 - 20
		})
	}

	componentWillMount() {
		AppStateStore.on("frontEndSettings_change", this.frontEndSettingsChange)
		appStateActions.getFrontEndSettings()
	}

	componentDidMount() {
		document.title = `${strings.Login} | ${strings.Findd_Grandd_Central}`
		dispatcher.register(this.handleActions)
		window.addEventListener("resize", this.handleResize)
		this.checkAuthentication()
		AuthenticationStore.on("change", this.changeEvent)
		if (enableIntercom()) {
			window["Intercom"]("boot", {
				app_id: "n9mo4v5d",
			});
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize, false)
		AuthenticationStore.removeListener("change", this.changeEvent)
	}

	changeEvent() {
		this.setState({
			sentRequestResetPassword: AuthenticationStore.getSentRequestResetPassword(),
			passwordUpdated: AuthenticationStore.getPasswordUpdated(),
		})
	}

	checkAuthentication() {
		if (AuthenticationStore.isLoggedIn()) {
			if (AccountStore.getProxyAccountId()) {
				AuthenticationStore.setIsAccountManager(false)
			}

			if (AuthenticationStore.getIsAccountManager()) {
				const defaultUrl = "/accountmanager"
				setTimeout(() => {
					browserHistory.replace(defaultUrl)
				}, 100)
			} else {
				const loggedInUserType = permissionHelper.getLoggedInUserType()
				let defaultUrl = loggedInUserType === ELoggedInUserType.Employee ? "/es/timecards" : "/dashboard"

				if (isMobile) {
					defaultUrl = "/mobile-dashboard"
				}

				setTimeout(() => {
					browserHistory.replace(defaultUrl)
				}, 100)
			}
		}
	}

	handleActions(action) {
		switch (action.type) {
			case "RECEIVE_AUTH_DATA": {
				this.checkAuthentication()
				break
			}
		}
	}

	handleEmailChange(e) {
		this.setState({ email: e.target.value }, () => {
			if (this.state.loginAttempted) {
				this.validateForm()
			}
		})
	}

	handlePasswordChange(e) {
		this.setState({ password: e.target.value }, () => {
			if (this.state.loginAttempted) {
				this.validateForm()
			}
		})
	}

	detectEnter(event) {
		event.keyCode === 13 && this.login()
	}

	login() {
		this.setState({ loginAttempted: true })
		this.validateForm() &&
			this.serverLogin(this.state.email, this.state.password)
	}

	serverLogin(email, password) {
		this.setState({ loadingStatus: "loading" })
		loginActions.login(email, password)
			.then(res => {
				this.setState({ loadingStatus: "hide" })
				if (!res.data) {
					this.setState({ emailErrorText: strings.invalid_email_password_combo })
				}
			})
			.catch(err => {
				var errorMsg = err.response.data.message as string
				this.setState({
					emailErrorText: errorMsg && errorMsg.includes("You are locked out") ? errorMsg : strings.something_went_wrong,
					loadingStatus: "hide"
				})
			})
	}

	validateForm() {
		this.setState({
			emailErrorText: "",
			passwordErrorText: ""
		})

		let isValidate = true
		if (!utils.validateEmail(this.state.email)) {
			this.setState({ emailErrorText: strings.Valid_email_required })
			isValidate = false
		}

		if (this.state.password.length === 0) {
			this.setState({ passwordErrorText: strings.Password_required })
			isValidate = false
		}

		return isValidate
	}

	render() {
		if (AuthenticationStore.isLoggedIn()) return null
		const { email, emailErrorText, password, passwordErrorText, loadingLeft, loadingTop, loadingStatus } = this.state
		const login = (
			<div>
				<div style={{ textAlign: "center" }}>
					<h2>Grandd Central {strings.Login}</h2>
					<div style={{ textAlign: "left", color: amber600 }}>
						{this.state.sentRequestResetPassword && strings.If_theres_Findd_account_linked_to_this_email_address}
						{this.state.passwordUpdated && strings.Your_password_has_been_updated}
					</div>
					<form id="LoginForm">
						<TextField
							floatingLabelText={strings.user_email}
							value={email}
							onChange={this.handleEmailChange}
							onKeyUp={this.detectEnter}
							errorText={emailErrorText}
							style={{ marginRight: 20, width: "100%", position: "relative" }}
							errorStyle={{ position: "absolute", left: 0, right: 0, bottom: -12 }}
							autoFocus
						/>
						<TextField
							floatingLabelText={strings.user_password}
							style={{ marginRight: 20, width: "100%", position: "relative" }}
							type="password"
							value={password}
							onChange={this.handlePasswordChange}
							onKeyUp={this.detectEnter}
							errorText={passwordErrorText}
							errorStyle={{ position: "absolute", left: 0, right: 0, bottom: -12 }}
						/>
						<div
							id="ForgotPassword"
							style={{ marginTop: 10, textAlign: "right", color: "rgba(0,0,0,0.4)", cursor: "pointer" }}
							onClick={() => browserHistory.push("forgot_password")}
						>
							{strings.Forgot_password}
						</div>
						<RaisedButton
							label={strings.Login}
							onClick={this.login}
							backgroundColor="#1181F2"
							labelColor="white"
							style={{ width: "100%", marginTop: 20 }}
						/>

						{/* We want to wind down the "self sign up" or "register new account" option for any web user
						    This should only be done via a new prospective client asking for a demo via the Findd web page
						<div style={{ marginTop: 20, color: "rgba(0,0,0,0.4)" }}>
							<p>— OR —</p>
						</div>
						<div style={{ marginTop: 20 }}>
							<a href="/account_registration" style={{ color: "rgba(0,0,0,0.4)" }}>Register New Account</a>
						</div> */}
					</form>
				</div>
				<RefreshIndicator left={loadingLeft} top={loadingTop} status={loadingStatus} />
			</div>
		)

		if (!this.state.frontEndSettings) {
			return (
				<div style={{ textAlign: "center", position: "absolute", top: "50%", left: "50%" }}><div style={{ padding: 20 }}>{strings.loading}</div></div>
			)
		}

		return (
			<RegistrationLayout
				leftContainer={login}
				rightContainer={
					<span style={{ padding: 30, color: "white" }}>
						<HtmlLoader htmlUrl={this.state.frontEndSettings ? this.state.frontEndSettings.UISettings.LoginHTMLURL : null} />
					</span>
				}
				loading={null}
				frontEndSettings={this.state.frontEndSettings}
			/>
		)
	}
}